import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-packages-assign',
  templateUrl: './packages-assign.component.html',
  styleUrls: ['./packages-assign.component.css']
})
export class PackagesAssignComponent implements OnInit {

  constructor(private auth : AuthService) { }

  ngOnInit() {
  }

}
